import { render, staticRenderFns } from "./RidesList.vue?vue&type=template&id=30ba818e&scoped=true"
import script from "./RidesList.vue?vue&type=script&lang=js"
export * from "./RidesList.vue?vue&type=script&lang=js"
import style0 from "./RidesList.vue?vue&type=style&index=0&id=30ba818e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba818e",
  null
  
)

export default component.exports